import React, { useLayoutEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useElementDimensions } from "@sportal/cdk/hooks";

import { useIsDesktop } from "../../../hocs/Responsive";
import { setPrimaryNavigationHeight } from "../../../store/layout";
import HorizontalMenu from "../horizontalMenu/HorizontalMenu";
import { DisclosureNavigation } from "./disclosureNavigation";

import "./MainNavigation.scss";

export const MainNavigation = () => {
  const navigationRef = useRef();
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();

  const { height } = useElementDimensions(navigationRef);

  useLayoutEffect(() => {
    dispatch(setPrimaryNavigationHeight(height));
  }, [dispatch, height]);

  return (
    <div ref={navigationRef} className={"main-navigation__wrapper"}>
      {isDesktop ? <DisclosureNavigation /> : <HorizontalMenu />}
    </div>
  );
};
